import { api, fileToBase64 } from "./api";

export async function validatePhoto({ image_base64, compare_against_phash = null }) {
    const { data } = await api.post("/validate/photo", {
        image_base64,
        compare_against_phash,
    });
    return data;
}

export async function otpSend(phone) {
    const { data } = await api.post("/otp/send", { phone });
    return data;
}

export async function otpVerify(phone, otp) {
    const { data } = await api.post("/otp/verify", { phone, otp });
    return data;
}

export async function submitCoupleQuestionnaire(payload) {
    const { data } = await api.post("/questionnaire/couple/submit", payload);
    return data;
}

export { fileToBase64 };
